import React from 'react';
import { withRouter } from 'react-router-dom';
import CONSTANT from '../../constant';
import Loader from '../../component/common/Loader';
import { getSelectedOrActiveCycle, getEmployeeQualificationTraining, saveEmployeeQualificationTraining, updateEmployeeQualificationTraining } from '../../actions/AppraisalCycleAction';

class QualificationsTraining extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            showLoader: false,
            employeeCode: '',
            appraisalCycleId: null,
            isExisting: false,
            qualificationList: [
                { id: 1, details: '', institution: '', marks: '' },
            ],
            trainingList: [
                { id: 1, dateFrom: '', dateTo: '', institute: '', subject: '' },
            ],
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        const employeeCode = this.props.match.params.code || '';
        document.title = 'Qualifications & Training - ' + CONSTANT.organisation.name;
        this.setState({ employeeCode }, () => {
            this.loadActiveCycleAndData();
        });
    }

    loadActiveCycleAndData = () => {
        this.setState({ showLoader: true });
        getSelectedOrActiveCycle().then((res: any) => {
            const cycle = res?.result;
            if (!cycle || !cycle.id) {
                alert('No appraisal cycle selected. Please select a cycle in the top bar.');
                this.setState({ showLoader: false });
                return;
            }
            this.setState({ appraisalCycleId: cycle.id }, () => {
                this.loadQualificationTrainingData();
            });
        }).catch(() => {
            this.setState({ showLoader: false });
        });
    };

    loadQualificationTrainingData = () => {
        const { employeeCode, appraisalCycleId } = this.state;
        getEmployeeQualificationTraining({ employeeCode, appraisalCycleId }).then((res: any) => {
            const data = res?.result || res || {};
            const qualifications = data.qualifications || [];
            const trainings = data.trainings || [];

            if (qualifications.length > 0 || trainings.length > 0) {
                this.setState({
                    isExisting: true,
                    qualificationList: qualifications.length > 0
                        ? qualifications.map((item: any, idx: number) => ({
                            id: idx + 1,
                            details: item.qualification_details || item.qualificationDetails || '',
                            institution: item.institution || '',
                            marks: item.subjects_marks != null ? String(item.subjects_marks) : (item.subjectsMarks != null ? String(item.subjectsMarks) : ''),
                        }))
                        : [{ id: 1, details: '', institution: '', marks: '' }],
                    trainingList: trainings.length > 0
                        ? trainings.map((item: any, idx: number) => ({
                            id: idx + 1,
                            dateFrom: this.formatDate(item.date_from || item.dateFrom),
                            dateTo: this.formatDate(item.date_to || item.dateTo),
                            institute: item.institute || '',
                            subject: item.subject || '',
                        }))
                        : [{ id: 1, dateFrom: '', dateTo: '', institute: '', subject: '' }],
                });
            }
            this.setState({ showLoader: false });
        }).catch(() => {
            this.setState({ showLoader: false });
        });
    };

    formatDate = (dateStr: string) => {
        if (!dateStr) return '';
        const d = new Date(dateStr);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    addQualificationRow = () => {
        const { qualificationList } = this.state;
        const newId = qualificationList.length > 0 ? qualificationList[qualificationList.length - 1].id + 1 : 1;
        this.setState({
            qualificationList: [...qualificationList, { id: newId, details: '', institution: '', marks: '' }],
        });
    };

    removeQualificationRow = (id: number) => {
        const rows = this.state.qualificationList.filter((item: any) => item.id !== id);
        this.setState({ qualificationList: rows });
    };

    handleQualificationChange = (id: number, field: string, value: string) => {
        const updated = this.state.qualificationList.map((item: any) =>
            item.id === id ? { ...item, [field]: value } : item
        );
        this.setState({ qualificationList: updated });
    };

    addTrainingRow = () => {
        const { trainingList } = this.state;
        const newId = trainingList.length > 0 ? trainingList[trainingList.length - 1].id + 1 : 1;
        this.setState({
            trainingList: [...trainingList, { id: newId, dateFrom: '', dateTo: '', institute: '', subject: '' }],
        });
    };

    removeTrainingRow = (id: number) => {
        const rows = this.state.trainingList.filter((item: any) => item.id !== id);
        this.setState({ trainingList: rows });
    };

    handleTrainingChange = (id: number, field: string, value: string) => {
        const updated = this.state.trainingList.map((item: any) =>
            item.id === id ? { ...item, [field]: value } : item
        );
        this.setState({ trainingList: updated });
    };

    validateForm = () => {
        const { qualificationList, trainingList } = this.state;

        for (let i = 0; i < qualificationList.length; i++) {
            const item = qualificationList[i];
            if (!item.details.trim()) {
                alert(`Qualification row ${i + 1}: Details of Qualification is required.`);
                return false;
            }
            if (!item.institution.trim()) {
                alert(`Qualification row ${i + 1}: Institution is required.`);
                return false;
            }
            if (!item.marks && item.marks !== 0) {
                alert(`Qualification row ${i + 1}: Marks obtained is required.`);
                return false;
            }
        }

        for (let i = 0; i < trainingList.length; i++) {
            const item = trainingList[i];
            if (!item.dateFrom) {
                alert(`Training row ${i + 1}: Date from is required.`);
                return false;
            }
            if (!item.dateTo) {
                alert(`Training row ${i + 1}: Date to is required.`);
                return false;
            }
            if (!item.institute.trim()) {
                alert(`Training row ${i + 1}: Institute is required.`);
                return false;
            }
            if (!item.subject.trim()) {
                alert(`Training row ${i + 1}: Subject is required.`);
                return false;
            }
        }

        return true;
    };

    onSubmit = (e: any) => {
        e.preventDefault();
        const { employeeCode, appraisalCycleId, isExisting } = this.state;

        if (!appraisalCycleId) {
            alert('No active appraisal cycle found');
            return;
        }

        if (!this.validateForm()) return;

        this.setState({ showLoader: true });

        const qualifications = this.state.qualificationList.map((item: any) => ({
            qualificationDetails: item.details,
            institution: item.institution,
            subjectsMarks: item.marks ? parseFloat(item.marks) : null,
        }));

        const trainings = this.state.trainingList.map((item: any) => ({
            dateFrom: item.dateFrom,
            dateTo: item.dateTo,
            institute: item.institute,
            subject: item.subject,
        }));

        const payload = { employeeCode, appraisalCycleId, qualifications, trainings };

        const apiCall = isExisting
            ? updateEmployeeQualificationTraining(payload)
            : saveEmployeeQualificationTraining(payload);

        apiCall.then((res: any) => {
            this.setState({ showLoader: false });
            if (res?.status === 'failed') {
                alert(res.error || 'Failed to save qualifications & training');
            } else {
                this.setState({ isExisting: true });
                alert(isExisting ? 'Qualifications & Training updated successfully!' : 'Qualifications & Training saved successfully!');
            }
        }).catch(() => {
            this.setState({ showLoader: false });
        });
    };

    render() {
        const { showLoader, employeeCode, qualificationList, trainingList } = this.state;

        return (
            <div className="container-fluid mb-3">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card homedob">
                            <div className="row">
                                <div className="col-md-8">
                                    <h1 className="page-title">
                                        <i className="fa fa-graduation-cap text-success mr-2" />
                                        Qualification acquired and Training programmes attended during the year
                                    </h1>
                                    <p className="text-muted mb-0">Employee Code: <strong>{employeeCode}</strong></p>
                                </div>
                                <div className="col-md-4 text-right">
                                    <button
                                        className="btn btn-sm cancel-button"
                                        onClick={() => this.props.history.goBack()}
                                    >
                                        <i className="fa fa-arrow-left mr-2" />
                                        Back
                                    </button>
                                </div>
                            </div>

                            {showLoader && <Loader />}

                            <form onSubmit={this.onSubmit}>
                                {/* Section 9(a) */}
                                <div className="mt-4">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h5 className="mb-0">
                                            (a) Details of Qualification acquired during the year
                                        </h5>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-primary"
                                            onClick={this.addQualificationRow}
                                        >
                                            <i className="fa fa-plus mr-1" />
                                            Add Row
                                        </button>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-bordered mb-0">
                                            <thead className="table-light">
                                                <tr className="text-center">
                                                    <th style={{ width: '5%' }}>#</th>
                                                    <th style={{ width: '25%' }}>Details of Qualification</th>
                                                    <th style={{ width: '25%' }}>Institution from which studied</th>
                                                    <th style={{ width: '30%' }}>Marks obtained</th>
                                                    <th style={{ width: '10%' }}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {qualificationList.map((item: any, idx: number) => (
                                                    <tr key={item.id}>
                                                        <td className="text-center align-middle">{idx + 1}</td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                value={item.details}
                                                                onChange={(e) => this.handleQualificationChange(item.id, 'details', e.target.value)}
                                                                placeholder="e.g. MBA, M.Tech"
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                value={item.institution}
                                                                onChange={(e) => this.handleQualificationChange(item.id, 'institution', e.target.value)}
                                                                placeholder="Institution name"
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control form-control-sm"
                                                                value={item.marks}
                                                                min="0"
                                                                max="100"
                                                                step="0.01"
                                                                onChange={(e) => {
                                                                    const val = e.target.value;
                                                                    if (val === '' || (Number(val) >= 0 && Number(val) <= 100)) {
                                                                        this.handleQualificationChange(item.id, 'marks', val);
                                                                    }
                                                                }}
                                                                placeholder="Marks obtained"
                                                            />
                                                        </td>
                                                        <td className="text-center align-middle">
                                                            {qualificationList.length > 1 && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-danger"
                                                                    onClick={() => this.removeQualificationRow(item.id)}
                                                                    title="Remove row"
                                                                >
                                                                    <i className="fa fa-trash" />
                                                                </button>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                {/* Section 9(b) */}
                                <div className="mt-4">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h5 className="mb-0">
                                            (b) Details of Training programme attended during the year
                                        </h5>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-primary"
                                            onClick={this.addTrainingRow}
                                        >
                                            <i className="fa fa-plus mr-1" />
                                            Add Row
                                        </button>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-bordered mb-0">
                                            <thead className="table-light">
                                                <tr className="text-center">
                                                    <th style={{ width: '5%' }}>#</th>
                                                    <th style={{ width: '20%' }}>Date from</th>
                                                    <th style={{ width: '20%' }}>Date to</th>
                                                    <th style={{ width: '22%' }}>Institute</th>
                                                    <th style={{ width: '23%' }}>Subject</th>
                                                    <th style={{ width: '10%' }}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {trainingList.map((item: any, idx: number) => (
                                                    <tr key={item.id}>
                                                        <td className="text-center align-middle">{idx + 1}</td>
                                                        <td>
                                                            <input
                                                                type="date"
                                                                className="form-control form-control-sm"
                                                                value={item.dateFrom}
                                                                onChange={(e) => this.handleTrainingChange(item.id, 'dateFrom', e.target.value)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="date"
                                                                className="form-control form-control-sm"
                                                                value={item.dateTo}
                                                                onChange={(e) => this.handleTrainingChange(item.id, 'dateTo', e.target.value)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                value={item.institute}
                                                                onChange={(e) => this.handleTrainingChange(item.id, 'institute', e.target.value)}
                                                                placeholder="Institute name"
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                value={item.subject}
                                                                onChange={(e) => this.handleTrainingChange(item.id, 'subject', e.target.value)}
                                                                placeholder="Subject"
                                                            />
                                                        </td>
                                                        <td className="text-center align-middle">
                                                            {trainingList.length > 1 && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-danger"
                                                                    onClick={() => this.removeTrainingRow(item.id)}
                                                                    title="Remove row"
                                                                >
                                                                    <i className="fa fa-trash" />
                                                                </button>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="d-flex justify-content-end mt-4 mb-2">
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary mr-2"
                                        onClick={() => this.props.history.goBack()}
                                    >
                                        <i className="fa fa-times mr-1" />
                                        Cancel
                                    </button>
                                    <button type="submit" className="btn btn-primary">
                                        <i className="fa fa-save mr-1" />
                                        Save
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(QualificationsTraining);
